import { styled } from '@mui/material';

export const FormItem = styled('div')`
  padding-bottom:20px;
  width:100%
`;


